module.exports = __webpack_public_path__ + "img/symbol_8.b0772601.png";